// extracted by mini-css-extract-plugin
export default {"root":"SideMenu_root__LWJWS","innerWrapper":"SideMenu_innerWrapper__GiGHC"};